import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SustainableDevelopmentGoal } from 'app/shared/objects/indicator';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-ods-indicator',
  templateUrl: './ods-indicator.component.html',
  styleUrls: ['./ods-indicator.component.scss']
})
export class OdsIndicatorComponent implements OnInit {
  sdgOpen: boolean;
  deployUrl: string;

  @Input() sdgData: SustainableDevelopmentGoal = null;

  constructor(
    public router: Router,
    public actived: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.sdgOpen = false;
    this.deployUrl = environment.deployUrl;
  }

  public hasIndicatorsData() {
    return this.sdgData !== undefined && this.sdgData != null;
  }

  openDesc() {
    this.sdgOpen = !this.sdgOpen;
  }

}
